import React, { useState } from "react";
import moment from "moment";

const HandlingOrderLineValidator = (props) => {
  const record = props.data.record;

  const [state, setState] = useState({
    error: null,
    errorMessage: null
  });

  let error = false;
  let errorMessage = "";

  /*
    Examples of validators - the record will have a copy of the working data
  */
  // if (!record.*code*) {
  //   error = true;
  //   errorMessage = "Please select a valid code";
  // } else if (!moment(record.*date*).isValid()) {
  //   error = true;
  //   errorMessage = "Please enter a valid date";
  // } else if (moment(record.*date1*).isBefore(record.*date2*)) {
  //   error = true;
  //   errorMessage = "The '*date1 name*' date cannot be before the '*date2 name' date";
  // } else if (record.*number* <= 0) {
  //   error = true;
  //   errorMessage = "The *number field* must be greater than zero";
  // }

  if (!error && (!record.airlineCode || !record.flightNo)) {
    error = true;
    errorMessage = "'Flight Number' is required";
  }
  if (!error && !record.originAirportCode) {
    error = true;
    errorMessage = "'ADEP' airport is required";
  }
  if (!error && !record.destinationAirportCode) {
    error = true;
    errorMessage = "'ADES' airport is required";
  }
  if (!error && record.destinationAirportCode === record.locationAirportCode) {
    error = true;
    errorMessage = "'Destination' airport cannot be the same as handling order location";
  }

  const arrival = moment(record.arrivalDate);
  const departure = moment(record.departureDate);

  if (!error && (!record.arrivalDate || !arrival.isValid())) {
    error = true;
    errorMessage = "'Arrival Date' is required";
  }
  if (!error && !record.scheduledArrivalTimeUTC) {
    error = true;
    errorMessage = "'STA (UTC)' is required";
  }
  if (!error && record.scheduledArrivalTimeUTC === "00:00") {
    error = true;
    errorMessage = "Please enter a valid Scheduled Arrival Time";
  }
  if (!error && (!record.departureDate || !departure.isValid())) {
    error = true;
    errorMessage = "'Departure Date' is required";
  }
  if (!error && departure.isBefore(arrival)) {
    error = true;
    errorMessage = "'Departure Date' must be after or equal to 'Arrival Date'";
  }
  if (!error && !record.scheduledDepartureTimeUTC) {
    error = true;
    errorMessage = "'STD (UTC)' is required";
  }
  if (!error && record.scheduledDepartureTimeUTC === "00:00") {
    error = true;
    errorMessage = "Please enter a valid Scheduled Departure Time";
  }
  if (!error && !record.cargo ) {
    error = true;
    errorMessage = "'Cargo' details is required";
  }


  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage });
    if (props.onChange) {
      props.onChange({ error, errorMessage });
    }
  }

  return (
    <div style={{display:"none"}}>
      {state.errorMessage}
    </div>
  );
}

export default HandlingOrderLineValidator;
